import styled from "styled-components";

// Por encima de la ficha de la actividad (z-index 9000), sobre la que se abre.
export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
`;

// Alto limitado a la ventana: la lista hace scroll y el pie queda siempre a la vista.
export const Modal = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: ${({ $wide }) => ($wide ? "1120px" : "560px")};
  max-height: calc(100vh - 48px);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.15rem;
  font-weight: 500;
  color: #1b2b3a;
`;

export const SearchWrap = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 256px;
  max-width: 100%;
  padding: 9px 14px;
  border-radius: 20px;
  background: #f0f3f5;
  color: #6b7a85;
`;

export const SearchInput = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  background: none;
  outline: none;
  font-size: 0.85rem;
  font-family: inherit;
  color: #1b2b3a;

  &::placeholder { color: #8a959e; }
`;

/* ── Filtros ── */
export const FilterRow = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 16px;
`;

export const FilterLabel = styled.span`
  font-size: 0.9rem;
  font-weight: 600;
  color: #1b2b3a;
  padding-bottom: 10px;
`;

export const FilterField = styled.label`
  flex: 1;
  min-width: 180px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FilterFieldLabel = styled.span`
  font-size: 0.82rem;
  color: #333;
`;

export const FilterSelect = styled.select`
  padding: 9px 10px;
  border-radius: 4px;
  border: 1px solid #c9d2d9;
  background: #fff;
  font-size: 0.85rem;
  font-family: inherit;
  color: #1b2b3a;

  &:disabled { background: #f0f3f5; color: #8a959e; }
`;

/* ── Lista ── */
export const OptionsList = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns || 1}, minmax(0, 1fr));
  gap: 16px 48px;
  align-content: start;
  padding: 2px;

  @media (max-width: 760px) { grid-template-columns: minmax(0, 1fr); }
`;

export const OptionRow = styled.label`
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
`;

export const Box = styled.span`
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  box-sizing: border-box;
  border-radius: ${({ $round }) => ($round ? "50%" : "4px")};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $checked }) => ($checked ? "#1b6b78" : "#fff")};
  border: 1.5px solid ${({ $checked }) => ($checked ? "#1b6b78" : "#c9d2d9")};
  /* El radio marcado es un punto: el anillo blanco lo separa del borde. */
  box-shadow: ${({ $checked, $round }) => ($checked && $round ? "inset 0 0 0 4px #fff" : "none")};
`;

// Oculto pero accesible: recibe el foco y lo anuncia el lector de pantalla.
export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
  margin: 0;

  &:focus-visible + ${Box} { outline: 2px solid #26A9B6; outline-offset: 2px; }
`;

export const Status = styled.p`
  margin: 0;
  padding: 32px 0;
  text-align: center;
  font-size: 0.85rem;
  color: #999;
`;

/* ── Pie ── */
export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;

export const CancelButton = styled.button`
  padding: 8px 15px;
  border-radius: 6px;
  border: 1px solid #1b6b78;
  background: #fff;
  color: #1b6b78;
  font-size: 0.85rem;
  font-family: inherit;
  cursor: pointer;

  &:hover { background: #f0f7f8; }
`;

export const ConfirmButton = styled.button`
  padding: 8px 15px;
  border-radius: 6px;
  border: 1px solid #1b6b78;
  background: #1b6b78;
  color: #fff;
  font-size: 0.85rem;
  font-family: inherit;
  cursor: pointer;

  &:hover { background: #175a65; }
  &:disabled { opacity: 0.5; cursor: default; }
`;
